export const copyLinkSuccess = {
  title: '已複製連結',
};
